import { Toast, ToastType, useToaster } from 'react-hot-toast'
import { Snackbar, snackbarContentClasses, SnackbarOrigin } from '@mui/material'

const notificationBgColor: Record<ToastType, string> = {
  blank: 'text.primary',
  success: 'success.main',
  error: 'error.main',
  loading: 'gray',
  custom: 'text.secondary',
}

export default function NotificationsProvider(): JSX.Element {
  const { toasts, handlers } = useToaster()
  const { calculateOffset, updateHeight } = handlers

  const notificationRender = (toast: Toast): JSX.Element => {
    const { id, position, height, visible, message, type, icon } = toast

    const anchorOriginObj: SnackbarOrigin = {
      vertical: 'top',
      horizontal: 'right',
    }

    if (position !== undefined) {
      const toastPositionArr = position.split('-')
      anchorOriginObj.vertical = toastPositionArr[0] as SnackbarOrigin['vertical']
      anchorOriginObj.horizontal = toastPositionArr[1] as SnackbarOrigin['horizontal']
    }

    const offset = calculateOffset(toast, {
      reverseOrder: false,
    })
    const offsetSign = anchorOriginObj.vertical === 'top' ? '' : '-'

    const transformCssValue = `translateY(${offsetSign}${offset}px)`

    const ref = (el: HTMLDivElement): void => {
      if (el !== null && height == null) {
        const height = el.getBoundingClientRect().height
        updateHeight(id, height)
      }
    }

    return (
      <Snackbar
        ref={ref}
        anchorOrigin={anchorOriginObj}
        open={visible}
        ContentProps={{
          role: type === 'error' ? 'alert' : 'status',
          'aria-live': type === 'error' ? 'assertive' : 'polite',
          'aria-atomic': true,
        }}
        message={
          <>
            {icon}
            {message}
          </>
        }
        key={id}
        sx={{
          [`& .${snackbarContentClasses.root}`]: {
            bgcolor: notificationBgColor[type],
          },
          transform: transformCssValue,
        }}
      />
    )
  }

  return <>{toasts.map(notificationRender)}</>
}
